import React, { View, Image } from 'react-native'
import infoButton from '../symbols/Info_button.png'
import { H1, H2, H3, TextDisplay } from '../TextStyles/TextStyles'

export const instructions = {
  instructions1: (
    <View>
      <H1>TERVETULOA!</H1>
      <TextDisplay>
        Sinä toimit kunnanvaltuustossa päättämässä minkälaisia energiaratkaisuja kuntaasi rakennetaan.
      </TextDisplay>
      <TextDisplay>
        Nämä ratkaisut vähentävät kaupungin hiilidioksidipäästöjä ja tuottavat myös taloudellisia säästöjä.
      </TextDisplay>
      <TextDisplay>
        Tavoitteenasi on siis pyrkiä vähentämään päästöjä ja samalla kerätä säästöjä kunnan kassaan.
      </TextDisplay>
    </View>
  ),
  instructions2: (
    <View >
      <TextDisplay>Kolme isoa korttia ovat projekteja, joita voit pelata pelilaudalle.</TextDisplay>
      <TextDisplay>Jokainen kortti tuottaa eri määrän päästövähennyksiä ja säästöjä.</TextDisplay>
    </View>
  ),
  instructions3: (
    <View>
      <H2>Kortin pelaaminen</H2>
      <TextDisplay>
        Kortin voi asettaa vain samanväriseen ruutuun. Kortin pelaaminen vähentää päästöjä ja kerää säästöjä.
      </TextDisplay>
      <H3>Vedä yksi korteista pelilaudalle.</H3>
    </View>
  ),
  instructions4: (
    <View>
      <H2>Kortin hylkääminen</H2>
      <TextDisplay>
        Osa korteista voi olla parempi jättää pelaamatta ja miettiä, mikä kortti tuottaisi parhaan yhdistelmän päästöjä ja säästöjä.
      </TextDisplay>
      <H3>Vedä yksi korteista roskakoriin.</H3>
    </View>
  ),
  instructions5: (
    <View>
      <H2>Lisätiedot korteista</H2>
      <TextDisplay>Jokaisen kortin vieressä on Info, josta löydät lisätietoja.</TextDisplay>
      <H3>Paina Info-nappia <Image style={{ width: 24, height: 22 }} source={infoButton} /> pelilaudalla.</H3>
    </View>
  ),
  instructions6: (
    <View>
      <H1>Hienoa!</H1>
      <TextDisplay>Nyt olet valmis pelaamaan!</TextDisplay>
      <TextDisplay>Sinulla on yhteensä 24 korttia kaupunkisi energiaratkaisuja varten.</TextDisplay>
    </View>
  )
}
